// mds-dojo — dijit/_editor/plugins/TextColor — FAITHFUL port of
// references/dijit/_editor/plugins/TextColor.js. Dropdown color pickers for foreColor
// and hiliteColor commands. Registers itself into _Plugin.registry.
//
// ADAPTATIONS:
//  - import paths repathed to mds; `dojo/_base/declare` → declare-runtime.
//  - DYNAMIC REQUIRE: the default color picker was lazy-loaded via AMD
//    `require([self.colorPicker], cb)` where colorPicker = "dijit/ColorPalette". That's
//    replaced by a static import of dijit/ColorPalette; the string branch now hands the
//    statically-imported ColorPalette to the loader callback (a passed constructor still
//    works). Non-default string module ids are no longer AMD-resolvable (flagged).
import colors from '../../../dojo/colors'; // colors.fromRgb
import declare from '../../../dojo/_base/declare-runtime'; // declare
import _Plugin from '../_Plugin';
import DropDownButton from '../../form/DropDownButton';
import ColorPalette from '../../ColorPalette';

// module:
//		dijit/_editor/plugins/TextColor

var TextColor: any = declare("dijit._editor.plugins.TextColor", _Plugin, {
	// summary:
	//		This plugin provides dropdown color pickers for setting text color and background color
	// description:
	//		The commands provided by this plugin are:
	//
	//		- foreColor - sets the text color
	//		- hiliteColor - sets the background color

	// Override _Plugin.buttonClass to use DropDownButton (with ColorPalette) to control this plugin
	buttonClass: DropDownButton,

	// colorPicker: String|Constructor
	//		The color picker dijit to use, defaults to dijit/ColorPalette
	colorPicker: "dijit/ColorPalette",

	// useDefaultCommand: Boolean
	//		False as we do not use the default editor command/click behavior.
	useDefaultCommand: false,

	_initButton: function(){
		this.command = this.name;

		this.inherited(arguments);

		// Setup to lazy load ColorPalette first time the button is clicked
		var self = this;
		this.button.loadDropDown = function(callback: any){
			function onColorPaletteLoad(ColorPaletteCtor: any){
				self.button.dropDown = new ColorPaletteCtor({
					dir: self.editor.dir,
					ownerDocument: self.editor.ownerDocument,
					value: self.value,
					onChange: function(color: any){
						self.editor.execCommand(self.command, color);
					},
					onExecute: function(){
						self.editor.execCommand(self.command, this.get("value"));
					}
				});
				callback();
			}
			if(typeof self.colorPicker == "string"){
				// mds: static import replaces AMD require([self.colorPicker], ...).
				onColorPaletteLoad(ColorPalette);
			}else{
				onColorPaletteLoad(self.colorPicker);
			}
		};
	},

	updateState: function(){
		// summary:
		//		Overrides _Plugin.updateState().  This updates the ColorPalette
		//		to show the color of the currently selected text.
		// tags:
		//		protected

		var _e = this.editor;
		var _c = this.command;
		if(!_e || !_e.isLoaded || !_c.length){
			return;
		}

		var value: any;
		if(this.button){
			var disabled = this.get("disabled");
			this.button.set("disabled", disabled);
			if(disabled){
				return;
			}

			try{
				value = _e.queryCommandValue(_c) || "";
			}catch(e){
				//Firefox may throw error above if the editor is just loaded, ignore it
				value = "";
			}
		}

		if(value == ""){
			value = "#000000";
		}
		if(value == "transparent"){
			value = "#ffffff";
		}

		if(typeof value == "string"){
			//if RGB value, convert to hex value
			if(value.indexOf("rgb") > -1){
				value = colors.fromRgb(value).toHex();
			}
		}else{    //it's an integer(IE returns an MS access #)
			value = ((value & 0x0000ff) << 16) | (value & 0x00ff00) | ((value & 0xff0000) >>> 16);
			value = value.toString(16);
			value = "#000000".slice(0, 7 - value.length) + value;

		}

		this.value = value;

		var dropDown = this.button.dropDown;
		if(dropDown && dropDown.get && value !== dropDown.get('value')){
			dropDown.set('value', value, false);
		}
	}
});

// Register this plugin.
_Plugin.registry["foreColor"] = function(args: any){
	return new TextColor(args);
};
_Plugin.registry["hiliteColor"] = function(args: any){
	return new TextColor(args);
};

export default TextColor;
